var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// CLAIM_FILE_PROCESSING_DELETE_ATTACHMENT
var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ClaimFileProcessingDeleteAttachment($id: ID!) {\n    claimFileProcessingDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"], ["\n  mutation ClaimFileProcessingDeleteAttachment($id: ID!) {\n    claimFileProcessingDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"])));
export default function useClaimFileProcessingDeleteAttachment() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'claimFileProcessingDeleteAttachment',
        successMessage: 'Attachment deleted'
    }), onClaimFileProcessingAttachmentDelete = _a.onMutate, loading = _a.loading;
    return { onClaimFileProcessingAttachmentDelete: onClaimFileProcessingAttachmentDelete, loading: loading };
}
var templateObject_1;
